import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { withRouter } from "../../../providers/withRouter";
import { Link } from "react-router-dom";
import { DataTable } from "../../../components";
import { CircularProgress, Tabs, Tab, Box } from "@mui/material";
import { getAAFFs } from "../../../services";
import WelcomeAlert from "../../../components/alerts/welcomeAlert";
import TabPanel from "../../../components/tabs/Tabs";
import ReclamationAlert from "../../../components/alerts/reclamationAlert";
import InformeAlert from "../../../components/alerts/informeAlert";
import { useLocation, useNavigate } from 'react-router-dom';
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../../functions/parametrosURL/funcionesParamsURL';

const AlertasAAFF = () => {
  const { t } = useTranslation('aaff');
  const location = useLocation();

  let params = new URLSearchParams(location.search);

  const tabParam = parseInt(params.get("valorTab") ) ;
  
  const urlPadre = window.location.pathname;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [value, setValue] = useState(tabParam || 0);
  const [limite, setLimite] = useState(0);
  const { filtrosIniciales } = useRecogerURLParamsFiltros();
  
  // useEffect(() => {
  //   fetchData();
  // }, [value, limite]); 

  // const fetchData = async ({ offset, limit, filtros = {} , order, orderBy} = {}) => {
    
  //   setLimite(limit);

  //   orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
  //   order =   order || filtroOrder.orden || 'ASC';

  //   const payload = {
  //     filtros,
  //     params: { page: offset, limit: limite, order,orderBy },
  //   };
  //   try {
  //     const response = await getAAFFs(payload);
  //     const { meta, data } = response;
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  

  const handleChange = (event, newValue) => {
    setValue(newValue);
    const currentParams = new URLSearchParams(location.search);
    const currentFiltros = {};
    for (let [key, value] of currentParams) {
      if (key !== 'valorTab' && key !== 'pagina' && key !== 'limite' && key !== 'orden' && key !== 'ordenadoPor') {
        currentFiltros[key] = value;
      }
    }
    construirURLParamsFiltros(navigate, 1, limite || 50, currentFiltros, newValue);
  };
  return (
    <>
      <BreadCrumb
        rutas={[{ path: "/alertas-aaff", label: t('alerts.title') }]}
        style={{ margin: "0 10px" }}
      />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">
            {t('alerts.title').toUpperCase()}
          </div>
          <Box sx={{ padding: '10px 40px', border: 'none' }}>
            <Tabs value={value} onChange={handleChange} aria-label="tabs example">
              <Tab style={{ color: "#92004D" }} label={t('alerts.welcome')} />
              <Tab style={{ color: "#92004D" }} label={t('alerts.reclamation')} />
              <Tab style={{ color: "#92004D" }} label={t('alerts.report')} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <WelcomeAlert valorTab={0}/>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <ReclamationAlert valorTab={1}/>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <InformeAlert valorTab={2}/>
          </TabPanel>
        </div>
      </div>
      <style jsx="true">{`
        .css-1aquho2-MuiTabs-indicator {
          background-color: #92004D;
        }
      `}</style>
    </>
  );
}

export default AlertasAAFF;
